// removed by extract-text-webpack-plugin
module.exports = {"container":"_2zY-zW_Oc_1nav1tjfjIu3","input":"_4CTU4ul0ty6yP5gMag4tB"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/Field/Menu/Text/styles.css
// module id = 3140
// module chunks = 0